import React from 'react';

interface CardProps {
  children: React.ReactNode;
  className?: string;
  variant?: 'default' | 'vata' | 'pitta' | 'kapha';
  hover?: boolean;
  style?: React.CSSProperties;
}

export function Card({ 
  children, 
  className = '', 
  variant = 'default',
  hover = false,
  style
}: CardProps) {
  const baseClasses = 'bg-white rounded-xl shadow-sm border p-6';
  
  const variantClasses = {
    default: 'border-neutral-200',
    vata: 'dosha-vata border-blue-200',
    pitta: 'dosha-pitta border-orange-200',
    kapha: 'dosha-kapha border-green-200'
  };
  
  const hoverClasses = hover ? 'hover:shadow-md transition-shadow duration-200 cursor-pointer' : '';
  
  const classes = `${baseClasses} ${variantClasses[variant]} ${hoverClasses} ${className}`;
  
  return (
    <div className={classes} style={style}>
      {children}
    </div>
  );
}